
  import {defineComponent, onMounted, reactive, toRefs} from "vue";

  export default defineComponent({
    name: 'informationEdit',
    setup(props, ctx) {
      const dataMap = reactive({
        subTitle: '请填写下方表单并确保信息的准确。我们将在1个工作日内与您联系，为您制定专属解决方案。如您希望即时沟通，可致电400-178-8338',
        dialogVisible: false,
        form: {
          name: '',
          unitName: '',
          phone: '',
          post: '',
          mailbox: '',
        },
        rules: {
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
          ],
          unitName: [
            {required: true, message: '请输入公司/单位名称', trigger: 'blur'},
          ],
          phone: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
          ],
          post: [
            {required: true, message: '请输入职位', trigger: 'blur'},
          ],
          mailbox: [
            {required: true, message: '请输入邮箱', trigger: 'blur'},
          ],
        }
      })
      onMounted(() => {
        dataMap.dialogVisible = true
      })
      return {
        ...toRefs(dataMap)
      }
    }
  })
